import React from 'react';
import './Login.css';
import { Navbar } from '../components/Navbar';
import { Link } from "react-router-dom";
import { ClompApi } from '../api/ClompApi';

const api = new ClompApi();

// Names shown for the games that can sign in through this page
const GAME_NAMES = { spacejump: 'Space Jump', solarflare: 'Solarflare' };

// Where a game sends its player to sign in: /link?code=XXXXXXXX. The player, logged in here, approves the code and
// the waiting game is signed in to their account. No password is ever typed into the game.
export class LinkPage extends React.Component {

    constructor(props) {
        super(props);
        let code = new URLSearchParams(this.props.location.search).get('code') || '';
        this.state = {
            code: code,
            typedCode: '',
            game: null,
            // 'checking' the code, 'ready' to approve, 'linking', 'linked', or 'invalid'
            step: code ? 'checking' : 'enter',
            error: '',
            username: '',
            loggedIn: localStorage.getItem('token') !== null
        };
    }

    componentDidMount() {
        if (this.state.code) {
            this.checkCode(this.state.code);
        }
    }

    checkCode(code) {
        this.setState({ code: code, step: 'checking', error: '' });
        api.games.getLink(code).then((link) => {
            this.setState({ game: link.game, step: 'ready' });
        }).catch(() => {
            this.setState({ step: 'invalid' });
        });
    }

    onSubmitCode = (event) => {
        event.preventDefault();
        if (this.state.typedCode.trim()) {
            this.checkCode(this.state.typedCode.trim());
        }
    }

    onApprove = () => {
        this.setState({ step: 'linking', error: '' });
        api.games.approveLink(this.state.code).then((response) => {
            this.setState({ step: 'linked', username: response.username });
        }).catch((err) => {
            if (err.response && err.response.status === 401) {
                // The saved login has run out
                localStorage.removeItem('token');
                this.setState({ step: 'ready', loggedIn: false });
            } else if (err.response && err.response.status === 404) {
                this.setState({ step: 'invalid' });
            } else {
                this.setState({ step: 'ready', error: "Couldn't reach the server. Please try again." });
            }
        });
    }

    renderBody() {
        let gameName = GAME_NAMES[this.state.game] || 'your game';
        let step = this.state.step;

        if (step === 'enter' || step === 'invalid') {
            return (
                <>
                    <p className="login-intro">
                        {step === 'invalid' ? "That code has expired or was already used. Start again from the game, or enter a new code."
                            : "Enter the code shown in your game."}
                    </p>
                    <form className="login-form" onSubmit={this.onSubmitCode} noValidate>
                        <label htmlFor="link-code">Code</label>
                        <input id="link-code" name="code" type="text" autoComplete="off" autoCapitalize="characters" value={this.state.typedCode}
                            onChange={(e) => this.setState({ typedCode: e.target.value })} />
                        <button type="submit" className="login-btn login-btn-primary">Continue</button>
                    </form>
                </>
            );
        }
        if (step === 'checking') {
            return <p className="login-intro">Checking your code...</p>;
        }
        if (step === 'linked') {
            return (
                <p className="login-intro">
                    {gameName} is now signed in as <strong>{this.state.username}</strong>. You can close this tab and go back to the game.
                </p>
            );
        }
        if (!this.state.loggedIn) {
            let back = encodeURIComponent(`/link?code=${this.state.code}`);
            return (
                <>
                    <p className="login-intro">Log in to your clomp account to sign in to {gameName}.</p>
                    <Link className="login-btn login-btn-primary" to={`/login?next=${back}`}>Log in</Link>
                    <div className="login-divider"><span>New to clomp?</span></div>
                    <Link className="login-btn login-btn-ghost" to="/register">Create an account</Link>
                </>
            );
        }
        return (
            <>
                <p className="login-intro">
                    {gameName} is asking to sign in with your clomp account, so your scores can be saved and posted to the leaderboard.
                </p>
                <p className="login-notice">Only continue if you just pressed Sign in in the game yourself. Code: <strong>{this.state.code}</strong></p>
                {this.state.error ? <p className="login-error" role="alert">{this.state.error}</p> : null}
                <button type="button" className="login-btn login-btn-primary" disabled={step === 'linking'} onClick={this.onApprove}>
                    {step === 'linking' ? "Signing in..." : `Sign in to ${gameName}`}
                </button>
            </>
        );
    }

    render() {
        return (
            <>
                <Navbar history={this.props.history}></Navbar>
                <div className="login-page">
                    <div className="login-card">
                        <h1>Link a game</h1>
                        {this.renderBody()}
                    </div>
                </div>
            </>
        );
    }

}
